import { Button } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import "../Modal/Distributor/CreateDistributorModal.css";
import { PermissionEnum } from "../../constants/permissionService";

export default function FooterButtons(props) {
  const buttonType = props.buttonType || "submit";
  return (
    <div className="modal-footer">
      <div>
        {props.isEditMode && (
          <Button
            variant="outlined"
            className="action-button mr-4"
            onClick={props.onCancel}
          >
            Cancel
          </Button>
        )}
        {props.permissions?.includes(PermissionEnum.UPDATE) &&
          !props.isEditMode && (
            <Button
              variant={!props.editPermission ? "contained" : "outlined"}
              className="action-button mr-4"
              type={buttonType}
              disabled={!props.editPermission}
              onClick={props.onEdit}
            >
              Edit
            </Button>
          )}
        {props.showUpdateNext && (
          <Button
            variant="contained"
            type={buttonType}
            className="action-button mr-4"
            onClick={props.onUpdateNext}
            disabled={props.disableUpdateNext}
          >
            Update & Next
          </Button>
        )}
        {props.showSaveNext && (
          <Button
            variant="contained"
            type={buttonType}
            className="action-button mr-4"
            onClick={props.onSaveNext}
            disabled={props.disableSaveNext}
          >
            Save & Next
          </Button>
        )}
        {props.showUpdateDetail ? (
          <Button
            variant="contained"
            className="action-button"
            data-testId="update-details"
            type={buttonType}
            onClick={props.onUpdate}
            disabled={props.disableUpdateDetail}
          >
            Update Details
          </Button>
        ) : (
          <Button
            data-testid="save-button-1"
            variant="contained"
            className="action-button"
            type={buttonType}
            onClick={props.onSave}
            disabled={props.disableSaveDetail}
          >
            Save Details
          </Button>
        )}
        {props.showAddNew && (
          <Button
            variant="contained"
            type={buttonType}
            className="action-button mr-4 cus-pad-footer-button"
            onClick={props.onSaveAddNew}
            disabled={props.disableSaveAddNew}
          >
            Update & Add New
          </Button>
        )}
        {props.showupdateAddNew && (
          <Button
            variant="contained"
            type={buttonType}
            className="action-button mr-4 cus-pad-footer-button"
            onClick={props.onSaveAddNew}
            disabled={props.disableUpdateAddNew}
          >
            Save & Add New
          </Button>
        )}
        {props.showUpdateDetail && props.isEditMode && props.permissionId === 2 && props.currentModule === "Add-Ins/Services" && (
          <Button
            variant="contained"
            type={buttonType}
            className="action-button mr-4 cus-pad-footer-button"
            onClick={props.onPublish}
            disabled={props.disablePublish}
          >
            Publish
          </Button>
        )}
        {props.showPublishNew && props.permissionId === 2 && props.currentModule === "Add-Ins/Services" && (
          <Button
            variant="contained"
            type={buttonType}
            className="action-button mr-4 cus-pad-footer-button"
            onClick={props.onNewPublish}
            disabled={props.disablePublish}
          >
            Publish
          </Button>
        )}
      </div>
    </div>
  );
}

FooterButtons.propTypes = {
  buttonType: PropTypes.string,
  isEditMode: PropTypes.bool,
  onCancel: PropTypes.func,
  permissions: PropTypes.arrayOf(PropTypes.string),
  editPermission: PropTypes.bool,
  onEdit: PropTypes.func,
  showUpdateNext: PropTypes.bool,
  onUpdateNext: PropTypes.func,
  disableUpdateNext: PropTypes.bool,
  showSaveNext: PropTypes.bool,
  onSaveNext: PropTypes.func,
  disableSaveNext: PropTypes.bool,
  showUpdateDetail: PropTypes.bool,
  onUpdate: PropTypes.func,
  disableUpdateDetail: PropTypes.bool,
  onSave: PropTypes.func,
  disableSaveDetail: PropTypes.bool,
  showAddNew: PropTypes.bool,
  onSaveAddNew: PropTypes.func,
  disableSaveAddNew: PropTypes.bool,
  showupdateAddNew: PropTypes.bool,
  disableUpdateAddNew: PropTypes.bool,
  permissionId: PropTypes.number,
  onPublish: PropTypes.func,
  disablePublish: PropTypes.bool,
  onNewPublish: PropTypes.func,
  currentModule: PropTypes.string,
  showPublishNew: PropTypes.bool
};
